<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      收货信息
    </div>
    <div class="rj-page-card__content">
      <Collapse :open="true">
        <div slot="header" class="header-mian">
          <span>配送至：</span>
          <div class="adressBox">
            <div v-if="address.isDefault" class="defTab">
              默认
            </div>
            <div class="item">
              {{ address.receiverName }}
            </div>
            <div class="item">
              {{ address.province }}
            </div>
            <div class="item">
              {{ address.city }}
            </div>
            <div class="item">
              {{ address.county }}
            </div>
            <div class="item">
              {{ address.receiptAddress }}
            </div>
            <div class="item">
              {{ address.receiverPhone }}
            </div>
          </div>
          <div v-if="!infoAll.freightContract" class="min-right">
            <el-button
              v-if="address.receiverName"
              :disabled="['SMB分销下单', '服务商分销下单'].includes(contractType)"
              type="text"
              style="padding: 0; margin-left: 15px"
              @click.stop="headSelectAddress"
            >
              更改地址
            </el-button>
            <el-button
              v-else
              :disabled="['SMB分销下单', '服务商分销下单'].includes(contractType)"
              type="text"
              style="padding: 0; margin-left: 15px"
              @click.stop="headSelectAddress"
            >
              选择地址
            </el-button>

            <el-form
              ref="baseForm"
              :model="formData"
              :inline="true"
              class="form-main"
            >
              <el-form-item label="特殊发货需求" required>
                <el-select v-model="formData.multiaddress" placeholder="请选择">
                  <el-option
                    v-for="item in warehouseList"
                    :key="item.dictLabel"
                    :label="item.dictValue"
                    :value="item.dictLabel"
                  />
                </el-select>
                <el-input
                  v-if="formData.multiaddress === '其他'"
                  v-model="multiaddressValue"
                  @click.native.stop="stopProp"
                />
              </el-form-item>

              <el-form-item label="特殊开票需求" required>
                <el-select
                  v-model="formData.specialTicketRequirements"
                  placeholder="请选择"
                  style="width: 150px"
                >
                  <el-option
                    v-for="(item, index) in specialInvoicingList"
                    :key="index"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  />
                </el-select>
                <!-- 选择[其他特殊需求]，填写内容 -->
                <el-input
                  v-if="formData.specialTicketRequirements === '其他特殊需求'"
                  v-model="formData.otherTxet"
                  :maxlength="100"
                  style="width: 200px"
                  @click.native.stop="() => {}"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
        <p
          v-if="infoAll.blackBoardProduct"
          style="margin-left: 10px; color: red"
        >
          【极其重要】智慧黑板RG-IIB-N86A下单要求：
          代理商下单过程请务必提供给平台商务「设备实际需要安装的地址」，且按照实际地址发货，否则新增地址上游供应商不予以上门安装，如有疑问请联系对应平台商务。
        </p>
        <p v-if="infoAll.flatProduct" style="margin-left: 10px; color: red">
          【极其重要】交互式智能平板（RG-IIB-K大屏）下单后的存储要求：
          因AG玻璃特性决定大屏存储期限只有3个月左右，如无法在收货后3个月内完成部署安装，因环境影响可能低概率出现玻璃水雾或霉变，此类情况非产品品质问题，若出现不支持退换，请联系400安排维修。
        </p>
        <slot name="freightInfo" :setProductInnerInfo="setProductInnerInfo" />
        <div style="padding: 20px">
          <p
            v-if="CustomizationList.length"
            style="padding: 10px 0; color: red"
          >
            此单涉及定制化产品，具体型号为：
            <el-tag v-for="(item, index) in CustomizationList" :key="index">
              {{ item.productName }}
            </el-tag>
            下单时请代理商支付此合同全部货款的30%进行下单，有疑问，请联系对应销售。
          </p>
          <el-form :inline="true" class="form-batch">
            <el-form-item>
              <el-date-picker
                v-model="allAttribute.time"
                type="date"
                :picker-options="setBatchPickerOptions()"
                :default-value="batchPickerDefaultValue"
                value-format="yyyy-MM-dd"
                placeholder="选择期望发货日期"
                :disabled="contractType==='SMB分销下单' && !isNewDeliveryRule && !hasEbgDeliveryRange"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="margin-right: 10px"
                :disabled="contractType==='SMB分销下单' && !isNewDeliveryRule && !hasEbgDeliveryRange"
                @click="batchSettings"
              >
                批量设置
              </el-button>
              <span v-if="infoAll.contractType === '国际业务下单' || infoAll.contractType === '国际分销下单'" style="color: red">
                注:1.若批量设置的日期不在客期可选范围,则需要重新设置或在产品行上单独设置
                2.若代理商发布合同时间和订单员发布合同时间间隔大于2天,则期望发货日期会在选择的日期上顺延相应间隔天数
              </span>
            </el-form-item>
            <el-form-item v-if="infoAll.contractType !== '国际业务下单' && infoAll.contractType !== '国际分销下单'">
              <el-button
                type="primary"
                style="margin-right: 10px"
                @click="batchSetAddress"
              >
                批量设置勾选产品收货地址(用于多地址发货)
              </el-button>
            </el-form-item>
            <el-form-item v-if="moreAddress && infoAll.contractType !== '国际业务下单' && infoAll.contractType !== '国际分销下单'">
              <el-button
                type="primary"
                style="margin-right: 10px"
                :loading="loading"
                @click="computedFee"
              >
                计算运费差价(多地址)
              </el-button>
            </el-form-item>
            <el-form-item>
              <span style="color: red">{{ infoAll.specialCloudDesc }}</span>
            </el-form-item>
          </el-form>
          <div v-if="infoAll.contractType !== '国际业务下单' && infoAll.contractType !== '国际分销下单'" style="color: red;margin-bottom: 10px;">
            注:1.若批量设置的日期不在客期可选范围,则需要重新设置或在产品行上单独设置
            2.若代理商发布合同时间和订单员发布合同时间间隔大于2天,则期望发货日期会在选择的日期上顺延相应间隔天数
            3.10月21日-12月15日之间的订单客期不能超过12月15日，12月16日-12月20日的订单客期不能超过12月20日（定制产品按供应SLA约束的除外，客期不能选节假日）
          </div>
          <el-table
            v-loading="amountPending > 0"
            :data="productList"
            border
            style="width: 100%"
            show-summary
            :summary-method="getSummaries"
            class="productTable"
            :height="tableHeight"
            @selection-change="handleSelectionChange"
          >
            <el-table-column v-if="infoAll.contractType !== '国际业务下单' && infoAll.contractType !== '国际分销下单'" type="selection" align="left" fixed="left" />
            <el-table-column
              type="index"
              width="70"
              label="序号"
              align="left"
              fixed="left"
            />
            <el-table-column
              prop="salesInvoiceName"
              label="产品名称"
              align="left"
              min-width="200"
              fixed="left"
            />
            <el-table-column
              prop="productName"
              label="产品型号"
              align="left"
              min-width="150"
              fixed="left"
            />
            <el-table-column
              prop="productNum"
              label="数量"
              align="left"
              width="120"
              fixed="left"
            >
              <template v-slot="{ row }">
                <el-input-number
                  v-if="isInternational"
                  v-model="row.productNum"
                  :disabled="row.isBorrow || amountPending > 0"
                  :min="1"
                  :controls="false"
                  style="width: 100%"
                  @blur="changeSetMoney(row)"
                />
                <div v-else>
                  <span v-if="infoAll.contractType === '服务订单'">{{
                    row.serviceLife
                  }}</span>
                  <span v-if="infoAll.contractType !== '服务订单'">{{
                    row.productNum
                  }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="unit"
              label="单位"
              align="left"
              width="70"
            />
            <el-table-column
              prop="productPriceSigle"
              label="单价"
              align="right"
              width="110"
              header-align="left"
            />
            <el-table-column
              prop="orderAmount"
              label="订单金额"
              align="right"
              width="110"
              header-align="left"
            >
              <template v-slot="{ row }">
                {{ $numToFixed(row.orderAmount) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="settlementAmount"
              label="实际结算金额"
              align="right"
              width="110"
              header-align="left"
            />
            <el-table-column
              prop="pname"
              label="期望发货日期"
              align="left"
              min-width="160"
            >
              <template v-slot="{ row }">
                <el-date-picker
                  v-model="row.expectedDeliveryDate"
                  type="date"
                  style="width: 100%"
                  :picker-options="setSinglePickerOptions(row)"
                  value-format="yyyy-MM-dd"
                  placeholder="期望发货日期"
                  :disabled="row.isBorrow || contractType==='SMB分销下单'"
                  :clearable="false"
                />
              </template>
            </el-table-column>

            <el-table-column
              v-if="!isUnDisabledConType || isNewDeliveryRule"
              label="客期可选范围"
              align="left"
              min-width="180"
            >
              <template v-slot="{ row }">
                <div class="text-left">
                  {{ setFormatRangDate(row) }}
                </div>
              </template>
            </el-table-column>

            <el-table-column v-if="isEbgDepartment" label="供应SLA" align="left" min-width="100">
              <template v-slot="{ row }">
                {{ row.supplySla == null ? '-' : `${row.supplySla}天` }}
              </template>
            </el-table-column>

            <el-table-column
              prop="beforeSplitProductPriceSigle"
              label="拆分前单价"
              align="right"
              width="110"
              header-align="left"
            />
            <el-table-column label="是否冲销" align="left" width="100">
              <template v-slot="{ row }">
                {{ row.isBorrow ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column
              label="税率"
              prop="rate"
              align="right"
              width="90"
              header-align="left"
            >
              <!-- <template v-slot="{row}">
                <el-select v-model="row.rate" placeholder="请选择税率">
                  <el-option v-for="item in taxRateList" :key="item.dictLabel" :label="item.dictValue" :value="item.dictLabel" />
                </el-select>
              </template> -->
            </el-table-column>
            <el-table-column
              prop="pname"
              label="是否购买PSC"
              align="left"
              width="100"
            >
              <template v-slot="{ row }">
                {{ row.isPsc ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="productConfigInfo"
              label="产品物料描述"
              align="left"
              width="100"
            />
            <el-table-column
              v-if="infoAll.manufactureRefurbished"
              prop="manufactureRefurbished"
              label="是否官翻机产品"
              align="left"
              width="180"
            >
              <template v-slot="{ row }">
                {{ row.manufactureRefurbished ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="detailedAddress"
              label="收货地址"
              align="left"
              width="200"
              :v-if="infoAll.contractType !== '国际业务下单' && infoAll.contractType !== '国际分销下单'"
            >
              <template v-slot="{ row }">
                {{ row.contactName? (row.contactName + row.receiverProvince + row.receiverCity + row.receiverDistrict + row.detailedAddress + row.contactPhone) : '' }}
              </template>
            </el-table-column>

            <el-table-column
              prop="serviceDesc"
              label="服务备注"
              align="left"
              min-width="180"
            />
            <el-table-column v-if="infoAll.contractType !== '国际业务下单' && infoAll.contractType !== '国际分销下单'" label="操作" width="180" align="left" fixed="right">
              <template v-slot="{row, $index}">
                <el-button type="text" @click="singleAddress(row, $index)">
                  选择地址
                </el-button>
                <img v-if="row.productNum > 1" class="addIcon" src="@/assets/add.svg" alt="" @click="copyRow(row, $index)">
                <img v-if="row.copy" class="deleteIcon" src="@/assets/delete.svg" alt="" @click="deleteRow(row, $index)">
              </template>
            </el-table-column>
          </el-table>
        </div>
      </Collapse>
      <slot />
    </div>
    <address-box
      :prop-open.sync="showAddress"
      @chooseAddress="changeAddress"
      @ChangeDatas="ChangeDatas"
    />
  </div>
</template>
<script type="es6">
import Collapse from '@/components/Collapse';
import addressBox from '@/views/address/index.vue';
import { mapState } from 'vuex';
import { getDictData } from '@/API/international';
import { getReceiptAddressByContractId, getReceiptAddressInfoModel, listSpecialTicketsRequirements, calculateProductSettlementAmount, moreAddressComputedFee, queryIsMoreAddress } from '@/API';
import { SMB_CONTRACT_NUM } from '@/constant/index.js';
import { getNum } from '@/libs/util';
import dayjs from 'dayjs';
import Big from 'big.js';

const EBG_DELIVERY_CONTRACT_TYPES = ['特价下单', '协议价下单', '非特价下单'];
export default {
  data () {
    return {
      allAttribute: {
        time: ''
      },
      tableData: [],
      showAddress: false,
      whereAddress: '1', // 1顶部地址 2批量设置地址 3单个数据地址
      multipleSelection: [],
      singleIndex: null,
      loading: true,
      amountPending: 0,
      amountRequestId: 0,
      amountPromise: null,
      address: {},
      finalNetSales: 0,
      orderSales: 0,
      productInnerInfo: null,
      tableHeight: 300,
      // 是否多地址发货
      formData: { multiaddress: '', specialTicketRequirements: null, otherTxet: '' },
      warehouseList: [],
      // taxRate: '',
      // taxRateList: []
      // 特殊开票需求
      specialInvoicingList: []
    };
  },
  props: {
    moreAddress: {
      type: Boolean,
      default: false
    },
    isComputePrice: {
      type: Boolean,
      default: false
    },
    departmentCode: {
      type: String,
      default: ''
    },
    contractType: {
      type: String,
      default: ''
    },
    productList: {
      type: Array,
      default () {
        return [];
      }
    },
    infoAll: {
      type: Object,
      default () {
        return {};
      }
    },
    contractId: {
      type: [String, Number],
      required: true
    },
    rebateAmount: {
      type: [String, Number],
      default: 0
    },
    rebate: {
      type: [Number],
      default: 1
    },
    freight: {
      type: [Number],
      default: 0
    },
    salesType: {
      type: [String, Number],
      default: ''
    },
    // 多地址发货
    multiaddress: {
      type: String,
      default: ''
    },
    multiaddressValue: {
      type: String,
      default: ''
    },
    // 是否直签项目
    asInterDirect: {
      type: Boolean,
      default: false
    },
    isPilot: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.queryWarehouse();
  },
  watch: {
    multiaddress: {
      immediate: true,
      handler (newVal) {
        this.formData.multiaddress = newVal;
      }
    },

    // 返利金额
    rebateAmount (newVal) {
      this.setFreightMoney();
    }
  },

  components: {
    Collapse,
    addressBox
  },
  computed: {
    ...mapState({
    }),
    // 定制化产品
    CustomizationList () {
      return this.productList.filter((item) => {
        return item.customizationOrNot;
      });
    },
    // 数量总计
    AmountTotal () {
      if (this.infoAll.contractType === '服务订单') {
        let cont = this.productList.reduce((pre, cur) => getNum(Big(getNum(cur.serviceLife)).plus(pre).toString()), 0);
        return cont;
      } else {
        let cont = this.productList.reduce((pre, cur) => getNum(Big(getNum(cur.productNum)).plus(pre).toString()), 0);
        return cont;
      }
    },

    // 订单金额总计
    computePriceTotal () {
      let cont = this.productList.reduce((pre, cur) => getNum(Big(getNum(cur.orderAmount)).plus(pre).toString()), 0);
      return cont;
    },
    // 实际结算金额总计
    settlementSumTotal () {
      let cont = this.productList.reduce((pre, cur) => getNum(Big(getNum(cur.settlementAmount)).plus(pre).toString()), 0);
      return cont;
    },
    // 拆分前单价总计
    beProductUnitPriceTotal () {
      if (this.contractType === '服务订单') {
        let cont = this.productList.reduce((pre, cur) => {
          return getNum(Big(getNum(cur.serviceLife)).times(getNum(cur.beforeSplitProductPriceSigle)).plus(pre).toString());
        }, 0);
        return cont;
      } else {
        let cont = this.productList.reduce((pre, cur) => {
          return getNum(Big(getNum(cur.productNum)).times(getNum(cur.beforeSplitProductPriceSigle)).plus(pre).toString());
        }, 0);
        return cont;
      }
    },

    // 接口不处理禁用客期规则的合同类型
    isUnDisabledConType () {
      if (this.hasEbgDeliveryRange) {
        return false;
      }
      return ['SMB分销下单', '国际业务下单', '国际分销下单', '新建订单合同', '服务订单'].includes(this.contractType);
    },
    hasEbgDeliveryRange () {
      return this.isEbgDepartment &&
        this.productList.some(row => row.newDeliveryRule === true && row.minExpectedDate && row.maxExpectedDate && Array.isArray(row.holidayDates));
    },
    isEbgDepartment () {
      return (this.departmentCode || '').startsWith('000062');
    },
    // 只有部门符合000062且命中试点配置时，才切换到EBG客期新规则。
    isNewDeliveryRule () {
      return this.isPilot && EBG_DELIVERY_CONTRACT_TYPES.includes(this.contractType) &&
        typeof this.departmentCode === 'string' && this.departmentCode.startsWith('000062');
    },
    isInternational () {
      console.log(!(['国际业务下单', '国际分销下单'].includes(this.infoAll.contractType) || (this.infoAll.contractType === '服务订单' && this.infoAll.civilInternational === 1)) && !['000063', '000036', '000101'].includes(this.infoAll.departmentCode.slice(0, 6)), 111);
      return !(['国际业务下单', '国际分销下单'].includes(this.infoAll.contractType) || (this.infoAll.contractType === '服务订单' && this.infoAll.civilInternational === 1)) && !['000063', '000036', '000101'].includes(this.infoAll.departmentCode.slice(0, 6));
    },
    // 批量选择客期时，默认定位到第一个可选日期所在月份。
    batchPickerDefaultValue () {
      if (this.allAttribute.time) {
        return dayjs(this.allAttribute.time).toDate();
      }

      const pickerOptions = this.setBatchPickerOptions();
      let defaultDate = dayjs().startOf('day');
      if (this.isNewDeliveryRule || this.hasEbgDeliveryRange) {
        const minDate = this.productList
          .filter(row => row.minExpectedDate)
          .map(row => dayjs(row.minExpectedDate))
          .sort((a, b) => a.valueOf() - b.valueOf())[0];
        if (minDate && minDate.isAfter(defaultDate, 'day')) {
          defaultDate = minDate.startOf('day');
        }
      }

      for (let offset = 0; offset <= 3660; offset++) {
        const candidate = defaultDate.add(offset, 'day');
        if (!pickerOptions.disabledDate(candidate.toDate())) {
          return candidate.toDate();
        }
      }
      return defaultDate.toDate();
    }
  },
  methods: {
    isMoreAddress (params) {
      queryIsMoreAddress(params).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.moreAddress = data;
          this.$emit('changeMoreAddress', data);
          if (data) {
            this.$emit('freightChange', 0, false);
          } else {
            this.address.id = this.productList[0].addressId;
            this.address.receiverName = this.productList[0].contactName;
            this.address.province = this.productList[0].receiverProvince;
            this.address.city = this.productList[0].receiverCity;
            this.address.county = this.productList[0].receiverDistrict;
            this.address.receiptAddress = this.productList[0].detailedAddress;
            this.address.receiverPhone = this.productList[0].contactPhone;
            let product = {
              salesInvoiceName: '价外费用-运费',
              productName: '价外费用-运费',
              productNum: 1,
              productCode: 'NG11400105',
              unit: '个',
              productPriceSigle: data,
              orderAmount: data,
              beforeSplitProductPriceSigle: data,
              pname: 0
            };
            this.$emit('freightChange', 0, false);
            this.$emit('reChange', { flag: 0, product });
          }
        }
      });
    },
    setProductInnerInfo (vm) {
      this.productInnerInfo = vm;
    },
    headSelectAddress () {
      this.$confirm('选择地址将覆盖全部产品地址，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.whereAddress = '1';
        this.showAddress = true;
      }).catch((e) => {
        console.error(e);
      });
    },
    batchSetAddress () {
      if (this.multipleSelection.length < 1) {
        this.$notify.error({
          title: '请选择需要设置地址的订单'
        });
        return;
      }
      this.whereAddress = '2';
      this.showAddress = true;
    },
    singleAddress (row, index) {
      this.whereAddress = '3';
      this.singleIndex = index;
      this.showAddress = true;
    },
    handleSelectionChange (val) {
      console.log(val);
      this.multipleSelection = val;
    },
    copyRow (row, index) {
      if (this.amountPending > 0) return;
      let copyData = JSON.parse(JSON.stringify(row));
      copyData.copy = true;
      copyData.idBak = row.id || row.idBak;
      copyData.id = null;
      this.productList.splice(index + 1, 0, copyData);
    },
    deleteRow (row, index) {
      if (this.amountPending > 0) return;
      this.productList.splice(index, 1);
    },
    // 数量、单价，变更调用接口计算获取：订单金额和实际结算金额
    changeSetMoney (row) {
      let params = {
        // 合同返点
        rebate: this.rebate,
        // 返利金额
        rebateAmount: this.rebateAmount,
        // 通讯折扣
        communicationOrderDiscount: 0,
        // 1 现销 2 赊销
        salesType: this.salesType,
        productList: this.productList.map((item) => ({
          id: item.id,
          productCode: item.productCode,
          productCategoryName: item.productCategoryName,
          productPriceSingle: item.productPriceSigle,
          productNum: item.productNum
        }))
      };
      return this.calculateAmounts(params);
    },
    calculateAmounts (params) {
      const rows = this.productList.slice();
      const values = rows.map(item => [item.productNum, item.serviceLife, item.productPriceSigle]);
      const requestId = ++this.amountRequestId;
      this.amountPending++;
      this.amountPromise = calculateProductSettlementAmount(params)
        .then(res => {
          if (requestId !== this.amountRequestId) return false;
          const { status, data, err } = res.data;
          if (status !== '200') {
            this.$message.error(err || '金额计算失败，请重试');
            return false;
          }
          const unchanged = rows.length === this.productList.length && rows.every((item, index) =>
            item === this.productList[index] && item.productNum === values[index][0] &&
            item.serviceLife === values[index][1] && item.productPriceSigle === values[index][2]);
          const valid = Array.isArray(data) && data.length === rows.length && data.every(item =>
            item && item.orderAmount !== null && item.orderAmount !== undefined &&
            item.settlementAmount !== null && item.settlementAmount !== undefined);
          if (!unchanged || !valid) {
            this.$message.error('产品数据或金额计算结果不一致，请重新计算');
            return false;
          }
          rows.forEach((item, index) => {
            item.orderAmount = data[index].orderAmount;
            item.settlementAmount = data[index].settlementAmount;
          });
          return true;
        })
        .catch(() => {
          if (requestId === this.amountRequestId) this.$message.error('金额计算失败，请重试');
          return false;
        })
        .finally(() => {
          this.amountPending--;
        });
      return this.amountPromise;
    },
    /**
     * 设置批量设置客期的禁用规则
     * 1. 接口处理的合同类型：当天开始的90天可以选择
     * 2. 服务商分销下单：从今天开始60天
     * 3. 服务订单：的产品不做限制，大于等于当天即可
     * 4. 其他：只能选择今天
    */
    setBatchPickerOptions () {
      let contractType = this.contractType;
      let orderSales = this.orderSales;
      let _this = this;

      return {
        disabledDate (time) {
          if ((_this.isNewDeliveryRule || _this.hasEbgDeliveryRange) &&
            ([0, 6].includes(dayjs(time).day()) || _this.productList.some(row => Array.isArray(row.holidayDates) && row.holidayDates.includes(dayjs(time).format('YYYY-MM-DD HH:mm:ss'))))) {
            return true;
          }
          if (_this.isNewDeliveryRule || _this.hasEbgDeliveryRange) {
            const minDate = _this.productList
              .filter(row => row.minExpectedDate)
              .map(row => dayjs(row.minExpectedDate))
              .sort((a, b) => a.valueOf() - b.valueOf())[0];
            const maxDate = _this.productList
              .filter(row => row.maxExpectedDate)
              .map(row => dayjs(row.maxExpectedDate))
              .sort((a, b) => b.valueOf() - a.valueOf())[0];
            return (minDate && dayjs(time).isBefore(minDate, 'day')) || (maxDate && dayjs(time).isAfter(maxDate, 'day'));
          } else if (!_this.isUnDisabledConType) {
            // 规则：直签项目 365 天可选择，其他当天开始的90天可以选择
            if (_this.asInterDirect) {
              return dayjs(time).isBefore(dayjs().subtract(1, 'day')) || dayjs(time).isAfter(dayjs().add(365, 'day'));
            } else {
              return dayjs(time).isBefore(dayjs().subtract(1, 'day')) || dayjs(time).isAfter(dayjs().add(89, 'day'));
            }
          } else if (contractType === '服务商分销下单' && orderSales > 150000) {
            // 从今天开始60天
            return dayjs(time).isBefore(dayjs().subtract(1, 'day')) || dayjs(time).isAfter(dayjs().add(59, 'day'));
          } else if (contractType === '服务订单') {
            // 服务订单的产品不做限制，大于等于当天即可
            return dayjs(time).isBefore(dayjs().subtract(1, 'day'));
          } else {
            // 只能选择今天;
            return !dayjs().isSame(dayjs(time), 'day');
          }
        }
      };
    },

    // 批量设置期望发货日期
    batchSettings () {
      const failedRows = [];
      this.productList.forEach((row, index) => {
        if (row.isBorrow) {
          if (this.allAttribute.time) {
            failedRows.push(`第${index + 1}行 ${row.productName || row.productCode || '未选择产品'}（冲销产品）`);
          }
          return;
        }
        if (this.allAttribute.time) {
          // 产品行符合禁用规则可以进行赋值
          if (!this.getRowDisabledRule(row, this.allAttribute.time)) {
            this.$set(row, 'expectedDeliveryDate', this.allAttribute.time);
          } else {
            failedRows.push(`第${index + 1}行 ${row.productName || row.productCode || '未选择产品'}`);
          }
        }
      });
      if (failedRows.length) {
        const message = this.$createElement('div', failedRows.map(label => this.$createElement('div', label)));
        this.$alert(message, '批量设置失败', { type: 'error' }).catch(() => null);
      }
    },

    /**
     * 产品行上期望发货日期禁用规则
     * 1. 接口处理的合同类型：产品行规则 小于开始，大于结束，中间的法定节假日 禁用(接口字段盘判断)
     * 1.1 冲销：只有最小时间(接口返回的数据)
     * 2. 服务商分销下单 && 金额 > 150000 : 从今天开始60天
     * 3. SMB分销下单 && 固定产品：今天~2023-09-20
     * 4. 服务订单：不做限制，大于等于当天即可
     * 5. 其他：只能选择今天
    */
    getRowDisabledRule (row, time) {
      let contractType = this.contractType;
      let orderSales = this.orderSales;

      if (row.isBorrow) {
        return true;
      }
      if ((this.isNewDeliveryRule || this.hasEbgDeliveryRange) && row.minExpectedDate && row.maxExpectedDate) {
        return dayjs(time).isBefore(dayjs(row.minExpectedDate), 'day') || dayjs(time).isAfter(dayjs(row.maxExpectedDate), 'day') ||
          [0, 6].includes(dayjs(time).day()) ||
          (Array.isArray(row.holidayDates) && row.holidayDates.includes(dayjs(time).format('YYYY-MM-DD HH:mm:ss')));
      } else if (!this.isUnDisabledConType) {
        // 禁用规则：id 存在小于开始，大于结束，中间的法定节假日， id 不存在是新增的“运费”，只可选60天
        if (row.id) {
          let { minExpectedDate, maxExpectedDate, holidayDates } = row;
          if (minExpectedDate && maxExpectedDate && holidayDates) {
            return dayjs(time).isBefore(dayjs(minExpectedDate)) || holidayDates.includes(dayjs(time).format('YYYY-MM-DD HH:mm:ss')) || dayjs(time).isAfter(dayjs(maxExpectedDate));
          } else if (minExpectedDate && !maxExpectedDate && !holidayDates) {
            // 冲销只有最小时间
            return dayjs(time).isBefore(dayjs(minExpectedDate));
          } else {
            return false;
          }
        } else {
          return dayjs(time).isBefore(dayjs().subtract(1, 'day')) || dayjs(time).isAfter(dayjs().add(59, 'day'));
        }
      } else if (contractType === '服务商分销下单' && orderSales > 150000) {
        // 从今天开始60天
        return dayjs(time).isBefore(dayjs().subtract(1, 'day')) || dayjs(time).isAfter(dayjs().add(59, 'day'));
      } else if (contractType === 'SMB分销下单' && SMB_CONTRACT_NUM.includes(row.productCode)) {
        // 只处理符合条件的产品型号
        return dayjs(time).isBefore(dayjs().subtract('1', 'day')) || dayjs(time).isAfter('2023-09-20');
      } else if (contractType === '服务订单') {
        // 服务订单的产品不做限制，大于等于当天即可
        return dayjs(time).isBefore(dayjs().subtract(1, 'day'));
      } else {
        // 只能选择今天;
        return !dayjs().isSame(dayjs(time), 'day');
      }
    },

    // 客期可选范围
    setFormatRangDate (row) {
      let { minExpectedDate, maxExpectedDate } = row;
      if (minExpectedDate && maxExpectedDate) {
        return `${dayjs(minExpectedDate).format('YYYY-MM-DD')} ~ ${dayjs(maxExpectedDate).format('YYYY-MM-DD')}`;
      } else if (minExpectedDate && !maxExpectedDate) {
        return `${dayjs(minExpectedDate).format('YYYY-MM-DD')} ~ `;
      }
    },

    // 设置产品行客期的禁用规则
    setSinglePickerOptions (row) {
      let _this = this;
      return {
        disabledDate (time) {
          return _this.getRowDisabledRule(row, time);
        }
      };
    },

    initData () {
      this.loading = false;
      getReceiptAddressByContractId(this.contractId).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          let data = json.data;
          if (data === null) {
            data = [];
          }
          this.address = data;
          if (this.infoAll.contractType !== '国际业务下单' && this.infoAll.contractType !== '国际分销下单') {
            this.productList.forEach((item) => {
              if (!item.contactName) {
                // item.addressId = data.id;
                item.contactName = data.receiverName;
                item.receiverProvince = data.province;
                item.receiverCity = data.city;
                item.receiverDistrict = data.county;
                item.detailedAddress = data.receiptAddress;
                item.contactPhone = data.receiverPhone;
              }
            });
          }
          this.$emit('chooseAddress', json.data);
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    stopProp (e) {
      e.stopPropagation();
    },
    queryWarehouse () {
      let params = { dictType: 'desc_of_special_requirements' };
      getDictData(params).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.warehouseList = data;
        }
      });
    },

    computedFee () {
      // if (this.multipleSelection.length < 1) {
      //   this.$message.error('请选择计算运费差价的数据');
      //   return;
      // }
      let freightInfo = this.productInnerInfo && this.productInnerInfo.info ? this.productInnerInfo.info : {};
      let params = {
        shippingType: freightInfo.shippingType !== undefined ? freightInfo.shippingType : this.infoAll.shippingType,
        contractNum: this.infoAll.contractNum,
        carrier: freightInfo.carrier || this.infoAll.carrier || '默认物流',
        agentId: this.infoAll.agentId,
        agentName: this.$store.state.user.userName,
        receiptAddressId: this.infoAll.receiptAddressId,
        contractProductInfos: this.infoAll.contractProductInfos
      };
      // if (this.productInnerInfo) {
      //   this.productInnerInfo.isHaveBattery = false;
      // }
      this.loading = true;
      moreAddressComputedFee(params).then(res => {
        this.loading = false;
        let { status, data } = res.data;
        if (status === '200') {
          console.log(data, '运费差价');
          if (data < 1) {
            this.$message.success(`差价在免费派送范围内，本次不收取多地址差价，请知悉`);
          }
          // this.infoAll.freight = data;
          let product = {
            salesInvoiceName: '价外费用-运费',
            productName: '价外费用-运费',
            productNum: 1,
            productCode: 'NG11400105',
            unit: '个',
            productPriceSigle: data,
            orderAmount: data,
            beforeSplitProductPriceSigle: data,
            pname: 0
          };
          this.$emit('freightChange', data, true);
          // 通知父组件产品列表添加运费一行
          if (data > 0) {
            this.$emit('reChange', { flag: 1, product });
          } else {
            this.$emit('reChange', { flag: 0, product });
          }
          // this.multipleSelection.forEach((item) => {
          //   item.receiverName = data;
          // });
        } else if (status === '7100023') {
          if (this.productInnerInfo && this.productInnerInfo.info) {
            this.productInnerInfo.isHaveBattery = true;
            this.productInnerInfo.info.shippingType = 0;
            this.productInnerInfo.info.freight = 0;
            this.productInnerInfo.info.freightPayType = 0;
          }
          this.$emit('freightChange', 0, false);
          this.$emit('reChange', { flag: 0 });
        } else {
          if (this.productInnerInfo && this.productInnerInfo.info) {
            this.productInnerInfo.info.freight = 0;
            this.productInnerInfo.info.freightPayType = 0;
            this.productInnerInfo.info.carrier = '默认物流';
            this.productInnerInfo.info.shippingType = 0;
          }
          this.$emit('freightChange', 0, false);
          this.$emit('reChange', { flag: 0 });
        }
      }).catch(() => {
        this.loading = false;
      });
    },

    // 合计行的计算
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.AmountTotal;
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = this.$numToFixed(this.computePriceTotal);
          this.orderSales = sums[index];
          this.$emit('orderSale', this.orderSales);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.settlementSumTotal;
          this.finalNetSales = sums[index];
          this.$emit('finalNet', this.finalNetSales);
          return;
        }
        if (column.label === '拆分前单价') {
          sums[index] = this.$numToFixed(this.beProductUnitPriceTotal);
        }
      });
      return sums;
    },
    changeAddress (val) {
      // 选择其他地址
      if (this.whereAddress === '1') {
        this.address = val;
        if (this.infoAll.contractType !== '国际业务下单' && this.infoAll.contractType !== '国际分销下单') {
          this.productList.forEach((item) => {
            item.addressId = val.id;
            item.contactName = val.receiverName;
            item.receiverProvince = val.province;
            item.receiverCity = val.city;
            item.receiverDistrict = val.county;
            item.detailedAddress = val.receiptAddress;
            item.contactPhone = val.receiverPhone;
          });
        }
      } else if (this.whereAddress === '2') {
        this.multipleSelection.forEach((item) => {
          item.addressId = val.id;
          item.contactName = val.receiverName;
          item.receiverProvince = val.province;
          item.receiverCity = val.city;
          item.receiverDistrict = val.county;
          item.detailedAddress = val.receiptAddress;
          item.contactPhone = val.receiverPhone;
        });
      } else if (this.whereAddress === '3') {
        this.productList[this.singleIndex].addressId = val.id;
        this.productList[this.singleIndex].contactName = val.receiverName;
        this.productList[this.singleIndex].receiverProvince = val.province;
        this.productList[this.singleIndex].receiverCity = val.city;
        this.productList[this.singleIndex].receiverDistrict = val.county;
        this.productList[this.singleIndex].detailedAddress = val.receiptAddress;
        this.productList[this.singleIndex].contactPhone = val.receiverPhone;
      }
      if (this.infoAll.contractType !== '国际业务下单' && this.infoAll.contractType !== '国际分销下单') {
        this.isMoreAddress(this.infoAll);
      }
      this.showAddress = false;
      this.$emit('chooseAddress', val);
      this.$emit('changeAddress');
    },
    ChangeDatas () {
      // 地址选择 地址源地址列表发生变化，需要用当前地址id 重新查询地址信息
      if (this.address.id) {
        getReceiptAddressInfoModel(this.address.id).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            if (!json.data.isDelete) {
              this.address = json.data;
            } else {
              this.address = {};
            }
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    },
    async validate () {
      let calculation = this.setFreightMoney();
      while (calculation) {
        const success = await calculation;
        if (calculation !== this.amountPromise) {
          calculation = this.amountPromise;
        } else {
          if (!success) return null;
          break;
        }
      }
      await this.$nextTick();
      let error = '';
      this.productList.forEach((item) => {
        if (!error) {
          if (!item.expectedDeliveryDate) {
            error = '存在产品未选择期望发货日期';
          }
          //  else if (!item.rate) {
          //   error = '存在产品未选择税率';
          // }
        }
      });

      return new Promise((resolve, reject) => {
        if (error) {
          this.$notify.error({
            title: error
          });
        } else {
          resolve(this.productList);
        }
      });
    },

    // 获取 特殊开票需求
    querySpecialTicketRequirements () {
      listSpecialTicketsRequirements().then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.specialInvoicingList = data;
        }
      });
    },

    // 生成运费 调用接口计算获取：订单金额和实际结算金额
    setFreightMoney () {
      let params = {
        // 合同返点
        rebate: this.rebate,
        // 返利金额
        rebateAmount: this.rebateAmount,
        // 通讯折扣
        communicationOrderDiscount: 0,
        // 1 现销 2 赊销
        salesType: this.salesType,
        productList: this.productList.map(row => {
          return {
            id: row.id,
            productCode: row.productCode,
            productCategoryName: row.productCategoryName,
            productPriceSingle: row.productPriceSigle,
            productNum: this.infoAll.contractType === '服务订单' ? row.serviceLife : row.productNum
          };
        })
      };
      return this.calculateAmounts(params);
    }

  },
  mounted () {
    this.initData();
    this.querySpecialTicketRequirements();
  }
};
</script>
<style lang="scss" scoped>
.productTable {
  .el-table__footer-wrapper tbody td {
    background: #fff;
  }
}
/* adress
-------------------------- */
.adressBox {
  display: inline-block;
  .item {
    display: inline-block;
    margin-right: 6px;
  }
  .defTab {
    padding: 3px 10px;
    display: inline-block;
    background: #1b73ff;
    font-size: 12px;
    color: #fff;
    border-radius: 4px;
    margin-right: 15px;
  }
}

.header-mian {
  display: flex;
  justify-content: flex-start;

  .min-right {
    display: flex;
    align-items: flex-start;
    flex: 1;
    .el-input--mini {
      width: 100px;
      margin-left: 10px;
    }
    .el-select {
      width: 100px;
    }
    button {
      position: relative;
      top: 4px;
    }

    .form-main {
      position: relative;
      top: -4px;
      flex: 1;
      margin-left: 30px;
    }

  }
}

.form-batch .el-form-item--mini.el-form-item{
  margin-bottom: 10px;
}

.addIcon, .deleteIcon {
    width: 24px;
    height: 24px;
    display: inline-block;
    margin: 0 0 0 5px;
    vertical-align: middle;
}

.text-left {
  text-align: left;
}
</style>
